import Cookies from 'js-cookie'
import { select } from 'redux-saga/effects'
import { RootState } from '../reducers/'

const redirectApplicantIdCookieName = 'monthio_redirect_applicant_id'

const getApplicantId = (state: RootState): string | null =>
	state.consumerAuthentication.sessionId

export function* storeRedirectWindowApplicantId(): Generator<
	unknown,
	void,
	string
> {
	const applicantId = yield select(getApplicantId)

	Cookies.set(redirectApplicantIdCookieName, applicantId, { expires: 1 })
}

export function* clearRedirectWindowApplicantId(): Generator<
	unknown,
	void,
	void
> {
	Cookies.remove(redirectApplicantIdCookieName)
}
